import axiosInstance from "../utils/axios";

/**
 * Returns platform URLs for provider registration.
 */
export const GetLtiPlatformConfig = async (cancelToken) => {
  return await axiosInstance().get("/getLtiPlatformConfig", { cancelToken });
};

/**
 * Returns paginated LTI integrations (or full list when exportStatus is true).
 */
export const GetLtiIntegrations = async (data, cancelToken) => {
  return await axiosInstance().post("/getLtiIntegrations", data, { cancelToken });
};

/**
 * Returns details for one integration.
 */
export const GetLtiIntegrationDetail = async (id, cancelToken) => {
  return await axiosInstance().get("/getLtiIntegrationDetail", {
    params: { id },
    cancelToken,
  });
};

/**
 * Creates new integration.
 */
export const AddLtiIntegration = async (values) => {
  return await axiosInstance().post("/addLtiIntegration", values);
};

/**
 * Updates existing integration.
 */
export const EditLtiIntegration = async (values) => {
  return await axiosInstance().post("/editLtiIntegration", values);
};

/**
 * Starts an authenticated Platform → Tool LTI launch and returns Tool login URL.
 */
export const InitiateLtiLaunch = async (values) => {
  return await axiosInstance().post("/initiateLtiLaunch", values);
};

/**
 * Runs test connection for integration.
 */
export const TestLtiIntegration = async (id) => {
  return await axiosInstance().post("/testLtiIntegration", { id });
};

/**
 * Fetches resources from integrated platform.
 */
export const GetLtiIntegrationResources = async (id, cancelToken) => {
  return await axiosInstance().get("/getLtiIntegrationResources", {
    params: { id },
    cancelToken,
  });
};

/**
 * Delete integration.
 */
export const DeleteLtiIntegration = async (values) => {
  return await axiosInstance().post("/deleteLtiIntegration", values);
};

/**
 * Returns paginated LTI integrations audit trail.
 */
export const GetLtiIntegrationAuditTrail = async (values, cancelToken) => {
  return await axiosInstance().post("/getLtiIntegrationAuditTrail", values, {
    cancelToken,
  });
};

/**
 * Returns filter dropdown data for LTI integrations audit trail.
 */
export const GetLtiIntegrationAuditTrailFilters = async (params, cancelToken) => {
  return await axiosInstance().get("/getLtiIntegrationAuditTrailFilters", {
    params,
    cancelToken,
  });
};